import { graphql } from "react-relay";

export const SendTestMessageMutation = graphql`
  mutation SendTestMessageMutation($input: SendTestMessageInput!) {
    sendTestMessage(input: $input) {
      message
      success
    }
  }
`;
